// Ricarica l'app quando torna in primo piano su una versione superata.
//
// Su iPhone uscire dall'app e rientrare non ricarica la pagina: iOS la
// congela e la riprende dalla memoria, col bundle vecchio ancora in
// esecuzione. Dopo un deploy si continua a lavorare sulla versione
// precedente senza accorgersene. Non è cache HTTP — nginx serve index.html
// con no-store — è che al rientro non si fa nessuna richiesta.
//
// Il confronto è fra il main.js che sta girando DAVVERO (letto dal tag
// <script> che l'ha caricato) e quello che il server pubblica ora. CRA
// mette l'hash del contenuto nel nome, quindi due nomi diversi = due build
// diverse.

const MANIFEST = '/asset-manifest.json';
// Versione per cui abbiamo già ricaricato: vedi vaRicaricato().
const STORAGE_KEY = 'clab.versioneRicaricata';

// Il bundle in esecuzione. Va letto dal DOM e non memorizzato all'avvio:
// dice cosa sta girando adesso, non cosa credevamo di aver caricato.
export function bundleInEsecuzione(doc = document) {
  const tag = doc.querySelector('script[src*="/static/js/main."]');
  if (!tag || !tag.src) return null;
  try { return new URL(tag.src, window.location.origin).pathname; } catch (_) { return null; }
}

export async function bundleSulServer() {
  // cache:no-store + querystring: il manifest deve arrivare dal server anche
  // quando è la cache del browser a essere in ritardo.
  const res = await fetch(`${MANIFEST}?t=${Date.now()}`, { cache: 'no-store' });
  if (!res.ok) return null;
  const data = await res.json();
  return data?.files?.['main.js'] || null;
}

/**
 * Decide se ricaricare.
 *
 * `giaRicaricatoPer` è la protezione contro il loop: se abbiamo già
 * ricaricato puntando a questa versione e il bundle in esecuzione è ancora
 * un altro, vuol dire che il reload non risolve (index.html arriva da una
 * cache che non controlliamo). Meglio restare sulla versione vecchia che far
 * ripartire la pagina all'infinito in mano all'operatore.
 *
 * Nel dubbio — un valore mancante — non si ricarica.
 */
export function vaRicaricato(inEsecuzione, sulServer, giaRicaricatoPer) {
  if (!inEsecuzione || !sulServer) return false;
  if (inEsecuzione === sulServer) return false;
  if (giaRicaricatoPer === sulServer) return false;
  return true;
}

export function avviaControlloVersione() {
  let inCorso = false;

  const controlla = async () => {
    if (document.visibilityState !== 'visible' || inCorso) return;
    inCorso = true;
    try {
      const inEsecuzione = bundleInEsecuzione();
      const sulServer = await bundleSulServer();
      let gia = null;
      try { gia = window.sessionStorage.getItem(STORAGE_KEY); } catch (_) {}
      if (vaRicaricato(inEsecuzione, sulServer, gia)) {
        try { window.sessionStorage.setItem(STORAGE_KEY, sulServer); } catch (_) {}
        window.location.reload();
      }
    } catch (_) {
      // Offline, o server irraggiungibile: si riprova al prossimo rientro.
      // Un controllo di versione non deve mai essere il motivo per cui
      // l'inventario si ferma.
    } finally {
      inCorso = false;
    }
  };

  // visibilitychange copre il rientro in primo piano; pageshow copre il
  // ritorno dalla back-forward cache di Safari, che non emette il primo.
  document.addEventListener('visibilitychange', controlla);
  window.addEventListener('pageshow', controlla);
}
